import produce from 'immer';
export function removeField(input, field, recursive = true) {
    const removeInDraft = (obj) => {
        // @ts-ignore
        Object.keys(obj).forEach((prop) => {
            if (prop === field) {
                // @ts-ignore
                delete obj[prop];
            }
            else {
                // @ts-ignore
                if (recursive && typeof obj[prop] === 'object' && obj[prop]) {
                    // @ts-ignore
                    removeInDraft(obj[prop]);
                }
            }
        });
    };
    return produce(input, (draft) => {
        removeInDraft(draft);
    });
}
export function removeTypeName(input) {
    return removeField(input, '__typename', true);
}
//# sourceMappingURL=removeField.js.map